import { CheckoutFormSection } from '../constants/checkoutForm';
import { VirtualIncentive } from '../models/user';
import { CheckoutState } from '../state';
import { getSelectedVirtualIncentivesAggregatedTotal } from '../utils/virtualIncentives';
import { getCheckoutFormSectionsWithError } from './forms';
import { getUnformattedOrderCost, hasVirtualIncentivesErrors } from './order';
import { getIsPayingWithVirtualIncentives } from './payment';
import { getVirtualIncentives } from './user';

export const getSelectedVirtualIncentives = (
    state: CheckoutState,
): Array<VirtualIncentive> => {
    const payWithVirtualIncentives = getIsPayingWithVirtualIncentives(state);
    if (!payWithVirtualIncentives) return [];

    const virtualIncentives = getVirtualIncentives(state);
    return virtualIncentives;
};

export const getIsPayingOrderOnlyWithVirtualIncentives = (
    state: CheckoutState,
): boolean => {
    const totalOrderCostInCents = getUnformattedOrderCost(state);
    const selectedVirtualIncentives = getSelectedVirtualIncentives(state);

    const amountInCentsPayedWithVirtualIncentives =
        getSelectedVirtualIncentivesAggregatedTotal(selectedVirtualIncentives);

    return totalOrderCostInCents <= amountInCentsPayedWithVirtualIncentives;
};

export const getHasPartiallyPaidWithVirtualIncentives = (
    state: CheckoutState,
): boolean => {
    const isPayingWithVirtualIncentives =
        getIsPayingWithVirtualIncentives(state);
    if (!isPayingWithVirtualIncentives) {
        return false; // If buyer is not paying with Virtual Incentives then no VI can be held
    }

    const virtualIncentiveErrors = hasVirtualIncentivesErrors(state);
    if (virtualIncentiveErrors) {
        return true; // If Virtual Incentives payment itself failed, then no VI are held
    }

    const isPayingOrderOnlyWithVirtualIncentives =
        getIsPayingOrderOnlyWithVirtualIncentives(state);
    if (isPayingOrderOnlyWithVirtualIncentives) {
        return false; // If buyer has enough Virtual Incentives to pay the entire order then either the buyer has not tried to pay or they have already successfully paid
    }

    const sectionsWithErrors = getCheckoutFormSectionsWithError(state);
    const hasErrorsWithPaymentMethod = sectionsWithErrors.includes(
        CheckoutFormSection.payment,
    );

    return hasErrorsWithPaymentMethod; // Virtual Incentives are temporarily held if they are used to pay part of an order and the remaining of the order is paid with a payment method that failed
};
